import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import {Observer} from "mobx-react-lite";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ConfirmArticleOrderReceivedButtonProperties from './ConfirmArticleOrderReceivedButtonProperties';
import Link from '../../../ui_components/Link/Link';
import { useCommonContext } from '../../../contexts/CommonContext';
import ConfirmArticleOrderReceivedStore from './ConfirmArticleOrderReceivedStore';
import { useUserContext } from '../../../contexts/UserContext';

const ConfirmArticleOrderReceivedButton: React.FC<ConfirmArticleOrderReceivedButtonProperties> = ({
                                                                                  deliveryPersonId,
                                                                                  articleDeliveryId,
                                                                                  onUpdate = () => {},
}) => {

    const i18n = useI18nContext();
    const confirm = useConfirmation();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new ConfirmArticleOrderReceivedStore(commonContext, deliveryPersonId, articleDeliveryId);

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const handleOnclick = async () => {
        const success = await confirm(i18n.translate("CONFIRM_RECEIVED_CONFIRMATION"), '');
        if(success){
            const result = await store.confirmReceived();
            if (result) {
                onUpdate(result);
            }
        }       
    }

    const text = i18n.translate("CONFIRM_RECEIVED");


    return <Observer>
        {() => (
            <>
                <div><Link text={text} onClick={handleOnclick} disabled={store.loading}></Link></div>
            </>
        )}
    </Observer>
}

export default ConfirmArticleOrderReceivedButton;
